import React from 'react';
import ShortStoryList from './ShortStoryList';

const ShortStoryManager = () => {
    return <ShortStoryList />;
};

export default ShortStoryManager; 